<template>
<div class="d-flex h-100 w-100 justify-content-center dashboard-container">
  <div class="card dashboard-panel w-100">
    <!-- <div class="card-header"> -->
      <div class="nav-outer-wrapper">
        <b-navbar toggleable="md" type="dark" class="primaryNav">
          <b-navbar-brand><img src="../../assets/kegs-logo-sml.png" v-b-tooltip.hover title="KEGS Field Developer"></b-navbar-brand>
          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
          <!--START FIRST NAV SECTION (MAIN TOOLSET) -->
          <b-collapse is-nav id="nav_collapse">
            <span id="dashboard-title">Dashboard</span>
          </b-collapse>

          <project-browser></project-browser>
          <b-navbar-nav class="my-0 right-nav-btns">
            <b-nav-item>
              <b-button v-b-tooltip.hover.bottom title="User Menu"
                @click="toggleRightMenu"
                class="showRight nav-link user-menu-button bg-inverse">
                  <span class="menu-icon">
                    <icon name="bars"></icon>
                  </span></b-button>
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar>
      </div>
    <!-- </div> -->
    <div class="card-body container-fluid">
      <b-row>
        <b-col md="7">
          <b-row class="mb-3">
            <b-col>
              <div id='dashboard-main-table-container' class="flex-container p-2">
                <h6>Issues count by tracker per field</h6>
                <div id="legend-container">
                  <!-- TODO: dynamic width/height legend -->
                  <svg id="summary-legend"
                  width="100"
                  height="50"></svg>
                </div>

                <b-table hover id='dash-main-table' :items="trackerResults" :fields="fields">
                  <template  v-for="item in fields" class="dash-sum-header" :slot="'HEAD_'+ item.key" slot-scope="head">
                      <div v-b-tooltip.hover title='Zoom to on map'
                        class="dash-sum-header-name"
                        @click="getDetails(item.key)">{{item.label}}
                      </div>
                      <div class="dash-sum-header-link" v-if="item.query_id">
                        <a v-b-tooltip.hover title='Open issue list in redmine' href="#" @click="sumTableOpenRedmine(item.query_id)">link</a>
                      </div>
                  </template>

                  <template v-for="item in fields" class="dash-sum-cell" :slot="item.key" slot-scope="row">
                    <span v-if="item.pie">
                      <svg :id="row.item.name + '-' + item.key + '-pie'"
                        width="35"
                        height="25"
                        v-bind:tracker="row.item.name"
                        v-bind:custom_value="item.key">
                      </svg>
                    </span>
                    <!-- TODO: default field as config -->
                    <span v-else>{{row.item.name}}</span>
                  </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="details.length > 0">
            <b-col>
              <div id='dashboard-stats-container' class="flex-container p-2">
                <h6>System Issues</h6>
                <b-list-group flush id='dash-details-list'>
                  <b-list-group-item v-for="item in details" :key="'detail-'+ item.id"><b>{{item.tracker.name}}:</b> {{item.subject}} -> {{item.status.name}}</b-list-group-item>
                </b-list-group>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="5">
          <div id="dash-map-holder">
            <div id="dash-map" />
          </div>
          <div class='dash-outer-legend-container' v-if="$store.getters['map/activatedLegends'].length">
            <div class='legend-title'>Map Legend</div>
            <div class='inner-legend-container'>
              <b-list-group v-for="l in $store.getters['map/activatedLegends']" v-bind:key="l.name">
                <div class='legend-item-title'>{{l.name}}</div>
                <img :src="l.src"></img>
              </b-list-group>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>

</div>
</template>
<script>
import 'vue-awesome/icons/file'

import store from '../../store'
import Vue from 'vue'
import Map from 'ol/Map'
import * as control from 'ol/control'
import View from 'ol/View'
import ScaleLine from 'ol/control/ScaleLine'
import MapPlugin from '../../plugin/map'

import MapMousePointer from '../map/MapMousePointer'

import { select, event } from 'd3-selection'
import { scaleOrdinal } from 'd3-scale'
import { pie, arc } from 'd3-shape'

import ProjectBrowser from '../projects/ProjectBrowser.vue'

export default {
  components: {
    ProjectBrowser
  },
  props: {
    workpack_id: {
      default: null
    }
  },
  data() {
    return {
      trackerResults: [],
      issues: [],
      details: [],
      cellIds: [],
      // TODO move layer names to config
      layerName: 'v4:aor',
      detailLayerName: 'v4:aor_corridor',
      layer: {},

      // TODO: dashboard fields passed in as config
      fields: [{
          key: 'name',
          label: 'Name',
          pie: false,
          query_id: null
        },
        {
          key: '1',
          label: 'System 1',
          pie: true,
          query_id: 9
        },
        {
          key: '2',
          label: 'System 2',
          pie: true,
          query_id: 10
        },
        {
          key: '3',
          label: 'System 3',
          pie: true,
          query_id: 11
        },
        {
          key: '4',
          label: 'System 4',
          pie: true,
          query_id: 12
        },
        {
          key: '5',
          label: 'System 5',
          pie: true,
          query_id: 13
        },
        {
          key: '6',
          label: 'System 6',
          pie: true,
          query_id: 14
        },
        {
          key: '7',
          label: 'System 7',
          pie: true,
          query_id: 15
        },
        {
          key: '8',
          label: 'System 8',
          pie: true,
          query_id: 16
        },
        {
          key: '9',
          label: 'System 9',
          pie: true,
          query_id: 17
        },
        {
          key: '10',
          label: 'System 10',
          pie: true,
          query_id: 18
        }
      ]
    }
  },
  computed: {
    menuRightCls: {
      get() {
        return this.$store.getters['user/menuRightCls']
      },
      set(val) {
        this.$store.commit('user/menuRightCls', val)
      }
    },
    showProjectList: {
      get() {
        return this.$store.getters['project/showProjectList']
      },
      set(val) {
        this.$store.commit('project/showProjectList', val)
      },
    },
    // get configs project id & list of trackers
    trackerArray() {
      return this.$store.getters['user/settings'].filter(s => s.usedfor === 'ui' && s.param === 'dashboard_trackers')
        .map(s => s.value)[0]
    },
    custom_field_name() {
      return this.$store.getters['user/settings'].filter(s => s.usedfor === 'ui' && s.param === 'dashboard_field_name')
        .map(s => s.value)[0]
    },
    isDashboardEditor() {
      return this.$store.getters['user/user']['groups'] && this.$store.getters['user/user']['groups'].map(g => g.name).filter(name => name === 'dashboard').length > 0
    }
  },
  mounted() {
    if (!this.workpack_id && this.$store.getters['project/currentProject'] && this.$store.getters['project/currentProject'].workpack) {
      this.$router.push(`/dashboard/${this.$store.getters['project/currentProject'].workpack.id}`)
    }
    this.iniProjectsAndMap()
  },
  methods: {
    sumTableOpenRedmine (val) {
      // TODO: get redmine issue list params from config
      // let win = window.open('/api/redmine/issues?project_id=' + this.$store.getters['project/currentProject'].id + '&cf_194='+ val +'&group_by=cf_195&status_id=*')
      let win = window.open('/mine/projects/eric/issues?query_id='+val)
      win.focus()
    },
    zoomToLayers () {
      let layersZoom = this.$mapService.getLayersToZoom()
      if (!layersZoom.length) {
        this.$notify({
          title: 'ERROR',
          text: 'No common vector layers available',
          type: 'error'
        })
        return
      }
      this.layersZoom = layersZoom
      layersZoom.forEach(l => this.$mapService.zoomToLayer(l))
    },
    toggleRightMenu() {
      this.showProjectList = false
      this.menuRightCls = this.menuRightCls !== '' ? '' : 'spmenu-open'
    },
    generateLegend(colors) {
      let color = scaleOrdinal(colors)
      let legendRectSize = 18
      let legendSpacing = 4
      // TODO: make legend dynamic
      let status = ['Open', 'Closed']

      let legend = select('#summary-legend')

      colors.forEach((c, index) => {
        let g = legend.append("g").attr('transform', function(d, i) {
            let height = legendRectSize + legendSpacing
            let offset = height * index / 2
            let horz = 0
            let vert = index * height
            return 'translate(' + horz + ',' + vert + ')'
          })

        g.append('rect')
          .attr('width', legendRectSize)
          .attr('height', legendRectSize)
          .style('fill', color(index))
          .style('stroke', color(index))

        g.append('text')
          .attr('x', legendRectSize + legendSpacing)
          .attr('y', legendRectSize - legendSpacing)
          .text(status[index])
      })
    },
    generatePieChart(svg, data, colors) {
      let width = svg.attr("width")
      let height = svg.attr("height")
      let color = scaleOrdinal(colors)

      let radius = Math.min(width, height) / 2
      let g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")

      // Generate the pie
      let pieV = pie()

      // Generate the arcs
      let arcV = arc()
        .innerRadius(0)
        .outerRadius(radius)

      //Generate groups
      let arcs = g.selectAll("arc")
        .data(pieV(data))
        .enter()
        .append("g")
        .attr("class", "arc")

      //Draw arc paths
      arcs.append("path")
        .attr("fill", function(d, i) {
          return color(i)
        })
        .attr("d", arcV)
    },
    getLayer() {
      let me = this
      let clb = function(me) {

        setTimeout(function() {


          // me.$mapService.setLayerLabel(me.layer, ['aor_name'])
          // me.$store.commit('map/setLayerLabel', [me.layer['name'],
          //   ['aor_name']
          // ])
          me.zoomToLayers()
        }, 1000)

      }
      this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
        if (node && node.state == 'autoload' && node.data_type != 'base') {
          this.$mapService.toggleLayerLegend(node)
        }
        if (node['name'] == this.layerName) {
          this.layer = node
          clb(me)
        }
      })
    },
    getDetails(val) {
      let exists = this.$mapService._layerExists(this.layer)
      if (exists) {
        // this.details = this.issues.filter(i => i[this.custom_field_name] == val)

        let geom = exists.getSource().getFeatures().find(f => f.get('aor_name') == val).get('geo')
        if (geom) {
          this.$mapService.zoomToGeom(geom)

          // this.layer['checked'] = false
          // this.$store.dispatch('map/layerState', this.layer)
        }
      }
    },
    getIssues() {
      // request issues via redmine api
      this.$http.get(`/api/redmine/issues.json?project_id=${this.$store.getters['project/currentProject'].id}&limit=100&status_id=*`)
        .then(res => {
          this.$notify({
            title: 'SUCCESS',
            text: 'Loaded redmine issues',
            type: 'success'
          })
          // filter by tracker
          this.issues = res.body.issues.filter(i => this.trackerArray.includes(i.tracker.name))

          this.issueProgressPie(this.issues)
          let me = this
          setTimeout(function() {
            me.buildSummaryPies()
          }, 1000)


        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load issues',
            type: 'error'
          })
        })
    },
    buildSummaryPies() {
      // TODO: pass color pallet via service/config

      let colors = ['#E50000', '#4daf4a']

      this.generateLegend(colors)
      this.cellIds.forEach(c => {
        // USE cell id to pull element attribute to get counts from trackerResults
        let svg = select('#' + c)
        let counts = this.getClosedPerCustomValue(svg)
        // build pie chart
        this.generatePieChart(svg, counts, colors)
      })
    },
    getClosedPerCustomValue(svg) {
      let open = 0,
        closed = 0,
        tracker_name = svg.attr("tracker"),
        custom_value = svg.attr("custom_value")

      let tracker = this.trackerResults.find(t => t.name == tracker_name)

      tracker[custom_value].forEach(mapped_issue_id => {
        let issue = this.issues.find(i => i.id == mapped_issue_id)
        if (issue.status.name == 'Closed') {
          ++closed
        } else {
          ++open
        }
      })
      return [open, closed]
    },

    issueProgressPie(issues) {
      // get issue ids per tracker config custom value
      let data = []
      issues.forEach(i => {
        let c_ident = i.custom_fields.find(c => c.name == this.custom_field_name).value
        if (!c_ident) {
          return
        }

        let match = data.find(d => d && d.name == i.tracker.name)
        i[this.custom_field_name] = c_ident
        if (match && match[c_ident]) {
          match[c_ident].push(i.id)
        } else if (match) {
          this.cellIds.push(i.tracker.name + '-' + c_ident + '-pie')
          match[c_ident] = [i.id]
        } else {
          this.cellIds.push(i.tracker.name + '-' + c_ident + '-pie')
          i[this.custom_field_name] = c_ident
          let o = {
            name: i.tracker.name
          }
          o[c_ident] = [i.id]
          data.push(o)
        }
      })
      let me = this
      data.sort(function(a, b){
        return me.trackerArray.indexOf(a.name) - me.trackerArray.indexOf(b.name);
      });
      this.trackerResults = data
    },
    getWorkpackId () {
      return this.workpack_id || (this.$store.getters['project/currentProject'] ? this.$store.getters['project/currentProject'].workpack.id : null)
    },
    iniProjectsAndMap() {
      Vue.use(MapPlugin, {
        map: this.initMap()
      })

      let workpackId = this.getWorkpackId()
      if (workpackId) {
        workpackId = parseInt(workpackId)
      }
      this.$store.commit('user/loading', true)
      this.$store.commit('map/initialised', true)

      this.$apiProjects.loadProjects(projectsTree => {
        this.$store.commit('project/projects', projectsTree)
        workpackId && this.setCurrentProject(projectsTree, workpackId)
        this.$apiProjects.pollTaskStats()
        this.getIssues()
      }, err => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not load project list',
          type: 'error'
        })
      })
      if (!workpackId) {
        //show projects popup
        return
      }
      this.loadWorkpackLayers(workpackId)

    },
    initMap() {
      let center = null
      let resolution = null
      let mapScope = this.$store.getters['map/mapScope']
      if (mapScope && mapScope[this.workpack_id]) {
        center = mapScope[this.workpack_id]['center']
        resolution = mapScope[this.workpack_id]['resolution']
      }

      let scaleLineControl = new ScaleLine()

      let map = new Map({
        target: 'dash-map',
        layers: [],
        view: new View({
          center: center || [16824158.9688553, -3185807.29806573],
          zoom: resolution || 12
        }),
        controls: control.defaults({
          attribution: false,
          zoom: false
        }).extend([
          scaleLineControl
        ])
      })

      map.getView().on('change:center', () => {
        this.$store.commit('map/center', [this.workpack_id, map.getView().getCenter()])
      })

      map.getView().on('change:resolution', () => {
        this.$store.commit('map/resolution', [this.workpack_id, map.getView().getZoom()])
      })

      return map
    },
    loadWorkpackLayers(workpackId) {
      this.$apiLayers.loadLayers(workpackId, tree => {
        this.$store.commit('map/temporalLayers', [])
        this.$store.commit('map/layersTree', tree)
        this.$store.commit('map/layersLoaded', new Date().getTime())
        this.getLayer()
        if (this.injectStyle) {
          this.injectStyle()
        }
      }, res => {
        console.error(res)
      })
    },
    setCurrentProject (projectsTree, workpackId) {
      let walk = (node) => {
        if (node['children']) {
          node['children'].forEach(walk)
        }

        if (node.workpack && node.workpack.id === workpackId) {
          this.$store.commit('project/currentProject', node)
        }
      }
      projectsTree.forEach(walk)
    },
  },
  watch: {
    showProjectList (val) {
      if (val) {
        this.menuRightCls = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/MainDashboard.vue